// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/@nrwl/web/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".weekgames_table__3gzgo {\n  height: 200px;\n}", ""]);
// Exports
exports.locals = {
	"table": "weekgames_table__3gzgo"
};
module.exports = exports;
